"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetDailyEnergySavingData = void 0;
const react_1 = require("react");
const index_1 = require("../../index");
const useGetDailyEnergySavingData = (sensors, selectedHubId, days = 30, hubConfig) => {
    // Find all power monitor sensors for the selected hub
    const powerMonitorSensors = (0, react_1.useMemo)(() => sensors?.filter((sensor) => sensor.type === index_1.SensorType.POWER && sensor.hubId === selectedHubId) ?? [], [sensors, selectedHubId]);
    const sensorIds = (0, react_1.useMemo)(() => powerMonitorSensors.map((s) => s.id), [powerMonitorSensors]);
    const { data, weekComparison, loading, error } = (0, index_1.usePowerUsageEnergySavings)({
        sensorIds,
        days,
        enabled: sensorIds.length > 0,
        hubConfig,
    });
    return {
        data,
        weekComparison,
        loading,
        error,
        sensor: powerMonitorSensors[0],
        sensors: powerMonitorSensors,
    };
};
exports.useGetDailyEnergySavingData = useGetDailyEnergySavingData;
